'use strict';

var React = require('react');
var ClassNames = require('classnames');
var _ = require('lodash');

var CancelDoneButtons = React.createClass({

    propTypes: {
        disabled: React.PropTypes.bool,
        cancelClassName: React.PropTypes.string,
        cancelDoneMainClassName: React.PropTypes.string,
        doneClassName: React.PropTypes.string,
        id: React.PropTypes.string,
        onClickCancel: React.PropTypes.func.isRequired,
        onClickDone: React.PropTypes.func.isRequired
    },

    getDefaultProps: function () {
        return {
            disabled: false,
            id: 'noIndexDefined'
        };
    },

    clickButton: function (e) {
        var self = this,
            ev = _.cloneDeep(e);
        setTimeout( function() {
            if (_.includes(ev.currentTarget.id, 'Cancel')) {
                self.props.onClickCancel(ev);
            } else {
                self.props.onClickDone(ev);
            }
        }, 100);
    },

    render: function () {
        const containerStyle = ClassNames('cancel-done-buttons', this.props.cancelDoneMainClassName);
        const cancelStyle = ClassNames('btn btn-default btn-lg cancel-button', this.props.cancelClassName);
        const enabledStyle = ClassNames('btn btn-success btn-lg done-button', this.props.doneClassName);
        const disabledStyle = ClassNames('btn btn-info btn-lg done-button');
        const doneStyle = this.props.disabled ? disabledStyle : enabledStyle;

        return (
            <div className={containerStyle}>
                    <button type="button"
                            className={cancelStyle}
                            id={this.props.id + 'Cancel-' + this.props.index}
                            onMouseDown={this.clickButton}>
                        Cancel
                    </button>
                    <button type="button"
                            className={doneStyle}
                            id={this.props.id + 'Done-' + this.props.index}
                            disabled={this.props.disabled}
                            onMouseDown={this.clickButton}>
                        Done
                    </button>
            </div>
		);
    }
});

module.exports = CancelDoneButtons;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/CancelDoneButtons.jsx